module.exports = __webpack_public_path__ + "static/img/4006.259b7c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/components/4006.png
// module id = 713
// module chunks = 0 1 12